import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, forkJoin, Observable, of, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from '../models/user';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any>;
  public menuListSubject: BehaviorSubject<any>;
  public submenuListSubject: BehaviorSubject<any>;
  public headerMenuListSubject: BehaviorSubject<any>;
  public hideNavBar: BehaviorSubject<any>;
  public roleId: any;
  moduleListArray: any = [];
  menuObj = {
    path: "",
    title: "",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Admin"],
    // submenu: [],
  }
  erpAccssModuleName = ['Inventory Management', 'Procure to Pay', 'Patients Care', 'HRMS', 'Accounting', 'Core Finance', 'Assets Management',
    'Cost Control', 'Office and Admin', 'Students Care', 'Billing'];
  erpAccModulelist: any = [];
  erpAccessobj = {
    path: "/admin/dashboar-module",
    title: "ERP Access",
    iconType: "",
    icon: "fas fa-cubes  red_color",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["Admin"],
    submenu: [],
    moduleId: 5
  }

  // erpAccessobj = {
  //   path: "/admin/dashboard/LegalEntitySubModuleAssignment",
  //   title: "ERP Access",
  //   iconType: "",
  //   icon: "fas fa-cubes  red_color",
  //   class: "menu-toggle",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["Admin"],
  //   submenu: [],
  //   moduleId: 5
  // }
  constructor(private http: HttpClient, private router: Router) {
    this.currentUserSubject = new BehaviorSubject<any>(
      this.safeParse(localStorage.getItem('currentUser'))
    );
    this.menuListSubject = new BehaviorSubject<any>(
      this.safeParse(localStorage.getItem('menuList'))
    );
    this.submenuListSubject = new BehaviorSubject<any>(
      this.safeParse(localStorage.getItem('submenuList'))
    );
    this.headerMenuListSubject = new BehaviorSubject<any>(
      this.safeParse(localStorage.getItem('headerMenuList'))
    );
    this.currentUser = this.currentUserSubject.asObservable();
    this.hideNavBar = new BehaviorSubject<any>(false);
  }

  private safeParse(value: string | null): any {
    try {
      return value ? JSON.parse(value) : null;
    } catch (e) {
      return null;
    }
  }
  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }
  public get menuList(): any {
    return this.menuListSubject.value;
  }

  public get headerMenu(): any {
    return this.headerMenuListSubject.value;
  }

  public get isHideNavBar(): any {
    return this.hideNavBar.value;
  }
  private dropdownChangeSubject = new Subject<void>();

  dropdownChange$ = this.dropdownChangeSubject.asObservable();

  notifyDropdownChange() {
    this.dropdownChangeSubject.next();
  }

login(username: string, password: string) {
  return this.http
    .post<any>(`${environment.apiUrl}/loginApi.php`, {
      username,
      password,
    })
    .pipe(
      map((user) => {

        // 👉 Get current date & time
        const loginTime = new Date();

        // 👉 Store in localStorage (or sessionStorage if needed)
        localStorage.setItem('currentUser', JSON.stringify(user.result));
        localStorage.setItem('module', '0');

        // Store login time separately
        localStorage.setItem('sessionTime', loginTime.toISOString());
        localStorage.setItem('sessionTime', loginTime.toISOString());

        // OR store inside user object
        const userWithSession = {
          ...user.result,
          sessionTime: loginTime
        };

        localStorage.setItem('financialYearId', JSON.stringify(user.financialYearId));

        this.currentUserSubject.next(userWithSession);

        return user;
      })
    );
}

  logoutthenlogin(username: string, password: string) {
    return this.http
      .post<any>(`${environment.apiUrl}/LoginAndLogoutApi.php`, {
        username,
        password,
      })
      .pipe(
        map((user) => {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem('currentUser', JSON.stringify(user.result));
          this.currentUserSubject.next(user.result);
          return user;
        })
      );
  } 
  

  logintracker(data): Observable<any> {
    return this.http.post(`${environment.apiUrl}` + '/SysLoginTrackingApi.php', data).pipe(map(res => res));
  }

  GetServerTime(data): Observable<any> {
    return this.http.post(`${environment.configUrl}` + '/utility.php', data).pipe(map(res => res));
  }
  ChangePWD(data): Observable<any> {
    return this.http.post(`${environment.apiUrl}` + '/ChangePwd.php', data).pipe(map(res => res));
  }
  EmproleAccess(data): Observable<any> {
    return this.http.post(`${environment.apiUrl}` + '/EmployeeRoleAccessApi.php', data).pipe(map(res => res));
  }
  // Viewroledetails(): Observable<any> {
  //   return this.http.get(`${environment.apiUrl}` + '/View_Profile_ByUserid.php?userId=' + localStorage.getItem('userId')).pipe(map(res => res))
  // }

  LoginAccessArea(data): Observable<any> {
    return this.http.post(`${environment.apiUrl}` + '/LoginAccessArea.php', { id: data }).pipe(map(res => res));
  }

  viewModule(id, roleId, legalEntityId, bus, b): Observable<any> {
    return this.http.get(`${environment.apiUrl}` + '/ViewModuleApi.php?userId=' + id + "&roleId=" + roleId + "&legalentityid=" + legalEntityId +
      "&businessverticalid=" + bus + "&businessareaid=" + b).pipe(map(res => res))


  }

  subModuleList(id, userId, roleId, legalEntityId, bus, b): Observable<any> {
    return this.http.get(`${environment.apiUrl}` + '/subModuleViewApi.php?id=' + id + '&userId=' + userId + "&roleId=" + roleId + "&legalentityid=" + legalEntityId +
      "&businessverticalid=" + bus + "&businessareaid=" + b).pipe(map(res => res))
  }
  subSusbmenuList(id, subId, userId, roleId): Observable<any> {
    return this.http.get(`${environment.apiUrl}` + '/ManuViewAllApi.php?id=' + id + "&mid=" + subId + '&userId=' + userId + "&roleId=" + roleId).pipe(map(res => res))
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    localStorage.removeItem('userId');
    localStorage.removeItem('businessAreaId');
    localStorage.removeItem('businessSegmentsId');
    localStorage.removeItem('legalEntityId');
    localStorage.removeItem('locationId');
    localStorage.removeItem('businessAreaName');
    localStorage.removeItem('businessSegmentsName');
    localStorage.removeItem('legalEntityName');
    localStorage.removeItem('locationName');
    localStorage.removeItem('groupId');
    localStorage.removeItem('userFullName');
    localStorage.removeItem('departmentId');
    localStorage.removeItem('roleId');
    localStorage.removeItem('roleName');
    localStorage.removeItem('menuList');
    localStorage.removeItem('permission');
    localStorage.removeItem('headerMenuList');
    localStorage.removeItem('module');
    localStorage.removeItem('submodule');
    localStorage.removeItem('subsubModule');

    localStorage.removeItem('menuLinkId');
    localStorage.removeItem('moduleId');
    localStorage.removeItem('subModuleId');
    localStorage.removeItem('functionURL');
    localStorage.removeItem('loginTrackId');
    localStorage.removeItem('headerMenu');
    localStorage.removeItem('legalEntityAdminRoleId');
    localStorage.removeItem('groupAdminRoleId');
    this.currentUserSubject.next(null);
    this.menuListSubject.next(null);
    this.headerMenuListSubject.next(null);
    this.hideNavBar.next(true);
    return of({ success: false });
  }

  setRole(roleId) {
    this.roleId = roleId;
    localStorage.setItem("roleId", this.roleId);
    this.moduleList();
  }

  moduleList() {
    if (localStorage.getItem('userName') === "Super Admin") {
      this.moduleListArray = [
        {
          path: "/admin/dashboard/configurationsetting",
          title: "Configuration & Setting",
          iconType: "material-icons-two-tone",
          icon: "fas fa-cog  yellow_color",
          class: "",
          groupTitle: true,
          badge: "",
          badgeClass: "",
          role: ["Admin"],
          submenu: [],
          moduleId: 1
        },
        {
          path: "/admin/dashboard/view-client",
          title: "Client Listing",
          iconType: "material-icons-two-tone",
          icon: "font-50 fas fa-users blue1_color",
          class: "",
          groupTitle: true,
          badge: "",
          badgeClass: "",
          role: ["Admin"],
          submenu: [],
          moduleId: 2
        },
        {
          path: "/admin/dashboard/ProductLisenceComponent",
          title: "Product License",
          iconType: "material-icons-two-tone",
          icon: "font-50 fas fa-file-contract red_color",
          class: "",
          groupTitle: true,
          badge: "",
          badgeClass: "",
          role: ["Admin"],
          submenu: [],
          moduleId: 3
        },
        {
          path: "/admin/dashboard/dashboard-assignment",
          title: "Module Assignment",
          iconType: "material-icons-two-tone",
          icon: "fas fa-user-graduate green_color",
          class: "",
          groupTitle: true,
          badge: "",
          badgeClass: "",
          role: ["Admin"],
          submenu: [],
          moduleId: 2
        },
        {
          path: "/admin/dashboard/module-assignment",
          title: "Module Management",
          iconType: "material-icons-two-tone",
          icon: "fas fa-user-cog",
          class: "",
          groupTitle: true,
          badge: "",
          badgeClass: "",
          role: ["Admin"],
          submenu: [],
          moduleId: 3
        },

        {
          path: "/admin/dashboard/reports",
          title: "Reports",
          iconType: "material-icons-two-tone",
          icon: "",
          class: "",
          groupTitle: true,
          badge: "",
          badgeClass: "",
          role: ["Admin"],
          submenu: [],
          moduleId: 5
        }
      ];
      console.log("Super Admin moduleListArray>>>>", JSON.stringify(this.moduleListArray));
      localStorage.setItem('menuList', JSON.stringify(this.moduleListArray));
      this.menuListSubject.next(this.moduleListArray);
    } else {
      this.viewModule(localStorage.getItem('userId'), localStorage.getItem('roleId'), localStorage.getItem('legalEntityId'),
        localStorage.getItem('businessSegmentsId'), localStorage.getItem('businessAreaId')).subscribe((module) => {
          let moduleArray = [];
          module.forEach((m, i) => {
            let obj = { ...this.menuObj };
            obj.title = m.moduleName;
            obj.icon = m.moduleIcon;
            obj.path = '/admin/dashboar-module';
            obj['moduleId'] = m.moduleId;
            obj['class'] = this.erpAccssModuleName.indexOf(m.moduleName) != -1 ? "ml-sub-menu" : 'menu-toggle';
            moduleArray.push(obj);
          });
          this.moduleListArray = moduleArray;
          console.log(this.moduleListArray);
          if (module.length > 0) {
            this.subModule(this.moduleListArray);
          }
          //  else {
          //   this.menuListSubject.next(this.moduleListArray);
          //   Swal.fire({
          //     title: "No Access",
          //     text: "You don't have any Role Assigned to work Further.",
          //     icon: "error",
          //     showCancelButton: false,
          //     confirmButtonColor: "#3085d6",
          //     cancelButtonColor: "#d33",
          //     confirmButtonText: "Yes",
          //   }).then((result) => {
          //     if (result.value) {
          //       this.logout();
          //       this.router.navigate(["/authentication/signin"]);
          //     } else if (
          //       /* Read more about handling dismissals below */
          //       result.dismiss === Swal.DismissReason.cancel
          //     ) {
          //       this.logout();
          //       this.router.navigate(["/authentication/signin"]);
          //     }
          //   });
          // }
        });
    }
  }

  subModule(modulelist) {
    forkJoin(modulelist.map(m => {
      return this.subModuleList(m.moduleId, localStorage.getItem('userId'), localStorage.getItem('roleId'),
        localStorage.getItem('legalEntityId'), localStorage.getItem('businessSegmentsId'), localStorage.getItem('businessAreaId'))
    })).subscribe((res: any) => {
      let subModuleArray = [];

      res.forEach((s, i) => {
        subModuleArray[i] = [];
        s.forEach(s1 => {
          let obj = { ...this.menuObj };
          obj.title = s1.subModuleName;
          obj.icon = s1.icon;
          obj.path = '';
          // obj.class = 'ml-sub-menu';
          obj.class = 'ml-menu';
          // obj.path = '/'+s1.subModuleName;
          obj['submenu'] = [];
          obj['submoduleId'] = s1.submoduleId;
          subModuleArray[i].push(obj);
        });
      });
      this.moduleListArray.forEach((module, index) => {
        module['submenu'] = [];
        subModuleArray[index].forEach((e, i) => {
          e['moduleId'] = module['moduleId'];
        });
        module['submenu'] = subModuleArray[index];
      });
      this.erpAccModulelist = [];
      let finalMenulist = [];
      console.log("menu>>>>>>")
      this.moduleListArray.forEach(element => {
        if (this.erpAccssModuleName.indexOf(element.title) == -1) {
          finalMenulist.push(element);
        } else {
          this.erpAccModulelist.push(element);
        }
      });
      console.log("this.erpAccModulelist>>>", this.erpAccModulelist);
      this.erpAccModulelist.forEach(element => {
        console.log(element);
        if (element.submenu.length > 0 && (element.title != 'Accounting')) {
          element.submenu.forEach(s => {
            s.class = 'ml-menu2';
          });
        } else {
          element.submenu.forEach(s => {
            s.class = 'ml-sub-menu2';
            s.path = '/admin/dashboar-module'
          });
        }
      });
      console.log(localStorage.getItem("legalEntityId"));
      if (parseInt(localStorage.getItem("legalEntityId")) != 0 || localStorage.getItem('roleName') != "Group-Admin") {
        this.erpAccessSubMenu(this.erpAccModulelist, finalMenulist)
      } else {
        localStorage.setItem('menuList', JSON.stringify(finalMenulist));
        this.menuListSubject.next(finalMenulist);
      }


      // this.subSusbmenu(this.moduleListArray);
    });
  }

  erpAccessSubMenu(moduleList, finalMenulist) {
    const accountingModule = moduleList.find(m => m.title === "Accounting");
    const patientCareModule = moduleList.find(m => m.title === "Patients Care");

    let observables = [];
    let accountingSubmenus = [];
    let mrdReportsChildMenus = [];
    let mrdChildMenus = [];

    if (accountingModule && accountingModule.submenu.length > 0) {
      accountingModule.submenu.forEach((s, index) => {
        observables.push(
          this.subSusbmenuList(
            s.submoduleId,
            accountingModule.moduleId,
            localStorage.getItem('userId'),
            localStorage.getItem('roleId')
          )
        );
        accountingSubmenus.push(index); // maintain index map
      });
    }

    let mrdReportsSubmenu;
    let mrdSubmenu;
    
    if (patientCareModule && patientCareModule.submenu.length > 0) {
      // MRD Transit Reports
      mrdReportsSubmenu = patientCareModule.submenu.find(s => s.title === "MRD Transit Reports");
      if (mrdReportsSubmenu) {
        observables.push(
          this.subSusbmenuList(
            mrdReportsSubmenu.submoduleId,
            patientCareModule.moduleId,
            localStorage.getItem('userId'),
            localStorage.getItem('roleId')
          )
        );
      }
      
      // MRD
      mrdSubmenu = patientCareModule.submenu.find(s => s.title === "MRD");
      if (mrdSubmenu) {
        observables.push(
          this.subSusbmenuList(
            mrdSubmenu.submoduleId,
            patientCareModule.moduleId,
            localStorage.getItem('userId'),
            localStorage.getItem('roleId')
          )
        );
      }
    }

    if (observables.length > 0) {
      forkJoin(observables).subscribe((resList: any[]) => {
        let resultIndex = 0;

        // Handle Accounting Submenus
        if (accountingModule) {
          accountingSubmenus.forEach((submenuIndex, i) => {
            let submenuItems = resList[resultIndex];
            let submenu = submenuItems.map((m) => ({
              ...this.menuObj,
              title: m.menuLinkName,
              path: m.functionURL,
              moduleId: m.menuLinkId,
              permission: m.permission,
              role: [''],
              class: 'ml-menu3',
              submenu: []
            }));
            accountingModule.submenu[submenuIndex]['submenu'] = submenu;
            resultIndex++;
          });
        }

        // Handle MRD Reports
        if (mrdReportsSubmenu) {
          let mrdReportsResult = resList[resultIndex];
          mrdReportsChildMenus = mrdReportsResult.map((m) => ({
            ...this.menuObj,
            title: m.menuLinkName,
            path: m.functionURL,
            moduleId: m.menuLinkId,
            permission: m.permission,
            role: [''],
            class: 'ml-menu3',
            submenu: []
          }));
          mrdReportsSubmenu['submenu'] = mrdReportsChildMenus;
          mrdReportsSubmenu.class = 'ml-sub-menu2';
          mrdReportsSubmenu.path = "/admin/dashboar-module";
          resultIndex++;
        }
        
        // Handle MRD (same as MRD Transit Reports)
        if (mrdSubmenu) {
          let mrdResult = resList[resultIndex];
          mrdChildMenus = mrdResult.map((m) => ({
            ...this.menuObj,
            title: m.menuLinkName,
            path: m.functionURL,
            moduleId: m.menuLinkId,
            permission: m.permission,
            role: [''],
            class: 'ml-menu3',
            submenu: []
          }));
          mrdSubmenu['submenu'] = mrdChildMenus;
          mrdSubmenu.class = 'ml-sub-menu2';
          mrdSubmenu.path = "/admin/dashboar-module";
          resultIndex++;
        }

        // Final save
        this.erpAccessobj['submenu'] = moduleList;
        finalMenulist.push(this.erpAccessobj);
        localStorage.setItem('menuList', JSON.stringify(finalMenulist));
        this.menuListSubject.next(finalMenulist);
        console.log('menuList', JSON.stringify(finalMenulist));
      });
    } else {
      // No dynamic loading needed
      this.erpAccessobj['submenu'] = moduleList;
      finalMenulist.push(this.erpAccessobj);
      localStorage.setItem('menuList', JSON.stringify(finalMenulist));
      this.menuListSubject.next(finalMenulist);
    }
  }


  // subSusbmenu(moduleList) {
  //   moduleList.map((m) => {
  //     forkJoin(
  //       m.submenu.map((s, msi) => {
  //         return this.subSusbmenuList(s.submoduleId, m.moduleId, localStorage.getItem('userId'),localStorage.getItem('roleId'))
  //       })
  //     ).subscribe((res: any) => {
  //       let submenu = [];

  //       res.forEach((s, i) => {
  //         submenu[i] = [];
  //         s.forEach((m) => {
  //           let obj = { ...this.menuObj };
  //           obj.title = m.menuLinkName;
  //           obj.path = m.functionURL;
  //           obj['moduleId'] = m.menuLinkId;
  //           obj['permission'] = m.permission;
  //           obj['role'] = [''];
  //           obj['class'] = 'ml-menu2';
  //           obj['submenu'] = [];
  //           submenu[i].push(obj);
  //         });

  //       });
  //       m.submenu.forEach((s, i) => {
  //         m.submenu[i]['submenu'] = [];
  //         m.submenu[i]['submenu'] = submenu[i];
  //       });
  //       setTimeout(() => {
  //         this.menuListSet();
  //       }, 100);

  //     });
  //   });

  //   // this.erpAccessobj['submenu'] = this.erpAccModulelist;
  //   // finalMenulist.push(this.erpAccessobj);
  //   // console.log(finalMenulist);
  //   //  localStorage.setItem('menuList', JSON.stringify(finalMenulist));
  //   //   this.menuListSubject.next(finalMenulist);


  //   // console.log(this.moduleListArray);
  //   // setTimeout(() => {
  //   //   this.erpAccModulelist = [];
  //   //   let finalMenulist = [];
  //   //   this.moduleListArray.forEach(element => {
  //   //     if (this.erpAccssModuleName.indexOf(element.title) != -1) {
  //   //       element['class'] = 'ml-sub-menu';
  //   //       if (element.submenu.length > 0) {
  //   //         element.submenu.forEach(s => {
  //   //           s['class'] = 'ml-sub-menu2';
  //   //           if (s.submenu.length > 0) {
  //   //             s.submenu.forEach(s1 => {
  //   //               s1['class'] = 'ml-menu3';
  //   //             });
  //   //           }

  //   //         });
  //   //       }
  //   //       this.erpAccModulelist.push(element);
  //   //     }
  //   //     else {
  //   //       finalMenulist.push(element);
  //   //     }
  //   //   });
  //   //   console.log(finalMenulist);
  //   //   this.erpAccessobj['submenu'] = this.erpAccModulelist;
  //   //   if (this.erpAccessobj['submenu'].length > 0) {
  //   //     finalMenulist.push(this.erpAccessobj);
  //   //   }
  //   //   localStorage.setItem('menuList', JSON.stringify(finalMenulist));
  //   //   this.menuListSubject.next(finalMenulist);
  //   // }, 100);
  // }

  // menuListSet() {
  //   this.erpAccModulelist = [];
  //   let finalMenulist = [];
  //   this.moduleListArray.forEach(element => {
  //     if (this.erpAccssModuleName.indexOf(element.title) != -1) {
  //       element['class'] = 'ml-sub-menu';
  //       if (element.submenu.length > 0) {
  //         element.submenu.forEach(s => {
  //           s['class'] = 'ml-sub-menu2';
  //           if (s.submenu.length > 0) {
  //             s.submenu.forEach(s1 => {
  //               s1['class'] = 'ml-menu3';
  //             });
  //           }

  //         });
  //       }
  //       this.erpAccModulelist.push(element);
  //     }
  //     else {
  //       finalMenulist.push(element);
  //     }
  //   });
  //   this.erpAccessobj['submenu'] = this.erpAccModulelist;
  //   if (this.erpAccessobj['submenu'].length > 0) {
  //     finalMenulist.push(this.erpAccessobj);
  //   }


  //   localStorage.setItem('menuList', JSON.stringify(finalMenulist));
  //   this.menuListSubject.next(finalMenulist);
  // }
  setHeaderMenuList(menulist) {
    localStorage.setItem('headerMenuList', JSON.stringify(menulist));
    this.headerMenuListSubject.next(menulist);
  }

  setModule(list) {
    console.log(list);
    this.menuListSubject.next(list);
  }

  setSubmodule(list) {
    console.log(list);
    this.submenuListSubject.next(list);
  }

  getMenuList(submoduleId, moduleId) {

    if (submoduleId && moduleId) {
      this.subSusbmenuList(submoduleId, moduleId, localStorage.getItem('userId'), localStorage.getItem('roleId')).subscribe((res) => {
        // console.log(res);
        this.router.navigate([res[0].functionURL]);
        localStorage.setItem("menuLinkId", res[0].menuLinkId);
        localStorage.setItem("permission", res[0].permission);
        this.setHeaderMenuList(res);
      });
    }
  }
  setHideNavBar(yn) {
    console.log(yn);
    this.hideNavBar.next(yn);
  }
  apiUrl2 = environment.PharmacyUrl + '/login';
  apiUrl = environment.PharmacyUrl + '/ErpTokenGenerate';

  login2() {
    const body = {
      user_uuid: '202000000',     
      password: '123456'
    };
    return this.http.post<{ access_token: string }>(this.apiUrl2, body);
  }

}
